<template>
  <div :style="{ padding: '0 50px', marginTop: '64px', zIndex: 1 }">
    <div :style="{ background: '#fff', padding: '24px', minHeight: '880px' }">
      <!-- <h1>Labor market affects by population aging</h1> -->
      <a-row :gutter="[32, 16]">
        <a-col :span="16" :xs="24" :sm="24" :md="24" :lg="16">
          <PopulationRatio />
        </a-col>
        <a-col :span="8" :xs="24" :sm="24" :md="24" :lg="8" style="border-style:ridge">
          <a-row :span="16" :xs="24" :sm="24" :md="24" :lg="5">
            <p style="text-size:150%" >Click button to select country:</p>
          </a-row>
          <a-row :span="16" :xs="24" :sm="24" :md="24" :lg="19">
            <a-col :span="8" :xs="24" :sm="24" :md="24" :lg="8" >
              Asia<br />
              <a-button id="labor-japan-btn" class="labor-btn">Japan</a-button>
              <br>
              <a-button id="labor-china-btn" class="china-btn-color labor-btn"
                >China</a-button
              ><br>
              <a-button id="labor-turkey-btn" class="turkey-btn-color labor-btn"
                >Turkey</a-button
              >
              <br /><br />
              Australia<br>
              <a-button
                id="labor-australia-btn"
                class="australia-btn-color labor-btn"
                >Australia</a-button
              >
            </a-col>

            <a-col :span="8" :xs="24" :sm="24" :md="24" :lg="8">
              Europe<br>
              <a-button id="labor-italy-btn" class="italy-btn-color labor-btn"
                >Italy</a-button
              ><br />
              <a-button
                id="labor-finland-btn"
                class="finland-btn-color labor-btn"
                >Finland</a-button
              ><br />
              <a-button id="labor-france-btn" class="france-btn-color labor-btn"
                >France</a-button
              ><br />
              <a-button id="labor-spain-btn" class="spain-btn-color labor-btn"
                >Spain</a-button
              ><br />
              <a-button id="labor-uk-btn" class="uk-btn-color labor-btn"
                >UK</a-button
              >
              <br />
              <a-button
                id="labor-iceland-btn"
                class="iceland-btn-color labor-btn"
                >Iceland</a-button
              >
            </a-col>
            <a-col :span="8" :xs="24" :sm="24" :md="24" :lg="8">
              North America<br>
              <a-button id="labor-canada-btn" class="canada-btn-color labor-btn"
                >Canada</a-button
              ><br>
              <a-button id="labor-us-btn" class="us-btn-color labor-btn"
                >United States</a-button
              ><br>
              <a-button id="labor-mexico-btn" class="mexico-btn-color labor-btn"
                >Mexico</a-button
              ><br>
              <br /><br />
              South America<br>
              <a-button id="labor-chile-btn" class="chile-btn-color labor-btn"
                >Chile</a-button
              >
            </a-col>
          </a-row>
        </a-col>
      </a-row>

      <a-row :gutter="32">
        <a-col :span="24" :xs="24" :sm="24" :md="24" :lg="14">
          <RetireAge ref="retireAge" />
          <!-- <svg/> -->
        </a-col>
        <a-col :span="24" :xs="24" :sm="24" :md="24" :lg="10">
          <a-row>
            <a-col :span="10" :xs="24" :sm="10" :md="10" :lg="10">
              <UnemplyeeRatio ref="unemplyeeRatio" />
            </a-col>
            <a-col :span="14" :xs="24" :sm="14" :md="14" :lg="14">
              <LaborRatio ref="laborRatio" />
            </a-col>
          </a-row>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import * as d3 from "d3";
import LaborRatio from "../components/affect/laborMarket/laborRatio.vue";
import UnemplyeeRatio from "../components/affect/laborMarket/unemplyeeRatio.vue";
import PopulationRatio from "../components/effort/populationRatio.vue";
import RetireAge from "../components/affect/laborMarket/retireAge.vue";

export default {
  name: "AffectLaborMarket",
  components: {
    LaborRatio,
    UnemplyeeRatio,
    PopulationRatio,
    RetireAge,
  },
  data: function () {
    return {
      countries: this.$store.state.Countries,
    };
  },
  mounted() {
    this.selectCountryLineChart(this.countries[1]);
    d3.select("#labor-china-btn").on("click", () => {
      this.$refs.laborRatio.select("#labor-china-btn");
      this.$refs.laborRatio.redraw_pie_chart_1991();
      this.$refs.laborRatio.redraw_pie_chart_2000();
      this.$refs.laborRatio.redraw_pie_chart_2010();
      this.$refs.laborRatio.redraw_pie_chart_2019();

      this.$refs.unemplyeeRatio.select("#labor-china-btn");
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_1991();
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_2000();
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_2010();
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_2019();

      this.selectCountryLineChart(this.countries[0]);

      this.$refs.retireAge.select("#labor-china-btn");
      this.$refs.retireAge.draw_retire_age_bar_chart();

      this.switchBtnColor("labor-china-btn");
    });

    d3.select("#labor-japan-btn").on("click", () => {
      this.$refs.laborRatio.select("#labor-japan-btn");
      this.$refs.laborRatio.redraw_pie_chart_1991();
      this.$refs.laborRatio.redraw_pie_chart_2000();
      this.$refs.laborRatio.redraw_pie_chart_2010();
      this.$refs.laborRatio.redraw_pie_chart_2019();

      this.$refs.unemplyeeRatio.select("#labor-japan-btn");
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_1991();
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_2000();
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_2010();
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_2019();

      this.selectCountryLineChart(this.countries[1]);

      this.$refs.retireAge.select("#labor-japan-btn");
      this.$refs.retireAge.draw_retire_age_bar_chart();

      this.switchBtnColor("labor-japan-btn");
    });

    d3.select("#labor-italy-btn").on("click", () => {
      this.$refs.laborRatio.select("#labor-italy-btn");
      this.$refs.laborRatio.redraw_pie_chart_1991();
      this.$refs.laborRatio.redraw_pie_chart_2000();
      this.$refs.laborRatio.redraw_pie_chart_2010();
      this.$refs.laborRatio.redraw_pie_chart_2019();

      this.$refs.unemplyeeRatio.select("#labor-italy-btn");
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_1991();
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_2000();
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_2010();
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_2019();

      this.selectCountryLineChart(this.countries[2]);

      this.$refs.retireAge.select("#labor-italy-btn");
      this.$refs.retireAge.draw_retire_age_bar_chart();

      this.switchBtnColor("labor-italy-btn");
    });

    d3.select("#labor-finland-btn").on("click", () => {
      this.$refs.laborRatio.select("#labor-finland-btn");
      this.$refs.laborRatio.redraw_pie_chart_1991();
      this.$refs.laborRatio.redraw_pie_chart_2000();
      this.$refs.laborRatio.redraw_pie_chart_2010();
      this.$refs.laborRatio.redraw_pie_chart_2019();

      this.$refs.unemplyeeRatio.select("#labor-finland-btn");
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_1991();
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_2000();
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_2010();
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_2019();

      this.selectCountryLineChart(this.countries[3]);

      this.$refs.retireAge.select("#labor-finland-btn");
      this.$refs.retireAge.draw_retire_age_bar_chart();

      this.switchBtnColor("labor-finland-btn");
    });

    d3.select("#labor-france-btn").on("click", () => {
      this.$refs.laborRatio.select("#labor-france-btn");
      this.$refs.laborRatio.redraw_pie_chart_1991();
      this.$refs.laborRatio.redraw_pie_chart_2000();
      this.$refs.laborRatio.redraw_pie_chart_2010();
      this.$refs.laborRatio.redraw_pie_chart_2019();

      this.$refs.unemplyeeRatio.select("#labor-france-btn");
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_1991();
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_2000();
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_2010();
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_2019();

      this.selectCountryLineChart(this.countries[4]);

      this.$refs.retireAge.select("#labor-france-btn");
      this.$refs.retireAge.draw_retire_age_bar_chart();

      this.switchBtnColor("labor-france-btn");
    });

    d3.select("#labor-spain-btn").on("click", () => {
      this.$refs.laborRatio.select("#labor-spain-btn");
      this.$refs.laborRatio.redraw_pie_chart_1991();
      this.$refs.laborRatio.redraw_pie_chart_2000();
      this.$refs.laborRatio.redraw_pie_chart_2010();
      this.$refs.laborRatio.redraw_pie_chart_2019();

      this.$refs.unemplyeeRatio.select("#labor-spain-btn");
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_1991();
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_2000();
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_2010();
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_2019();

      this.selectCountryLineChart(this.countries[5]);

      this.$refs.retireAge.select("#labor-spain-btn");
      this.$refs.retireAge.draw_retire_age_bar_chart();

      this.switchBtnColor("labor-spain-btn");
    });

    d3.select("#labor-uk-btn").on("click", () => {
      this.$refs.laborRatio.select("#labor-uk-btn");
      this.$refs.laborRatio.redraw_pie_chart_1991();
      this.$refs.laborRatio.redraw_pie_chart_2000();
      this.$refs.laborRatio.redraw_pie_chart_2010();
      this.$refs.laborRatio.redraw_pie_chart_2019();

      this.$refs.unemplyeeRatio.select("#labor-uk-btn");
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_1991();
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_2000();
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_2010();
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_2019();

      this.selectCountryLineChart(this.countries[6]);

      this.$refs.retireAge.select("#labor-uk-btn");
      this.$refs.retireAge.draw_retire_age_bar_chart();

      this.switchBtnColor("labor-uk-btn");
    });

    d3.select("#labor-canada-btn").on("click", () => {
      this.$refs.laborRatio.select("#labor-canada-btn");
      this.$refs.laborRatio.redraw_pie_chart_1991();
      this.$refs.laborRatio.redraw_pie_chart_2000();
      this.$refs.laborRatio.redraw_pie_chart_2010();
      this.$refs.laborRatio.redraw_pie_chart_2019();

      this.$refs.unemplyeeRatio.select("#labor-canada-btn");
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_1991();
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_2000();
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_2010();
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_2019();

      this.selectCountryLineChart(this.countries[7]);

      this.$refs.retireAge.select("#labor-canada-btn");
      this.$refs.retireAge.draw_retire_age_bar_chart();

      this.switchBtnColor("labor-canada-btn");
    });

    d3.select("#labor-us-btn").on("click", () => {
      this.$refs.laborRatio.select("#labor-us-btn");
      this.$refs.laborRatio.redraw_pie_chart_1991();
      this.$refs.laborRatio.redraw_pie_chart_2000();
      this.$refs.laborRatio.redraw_pie_chart_2010();
      this.$refs.laborRatio.redraw_pie_chart_2019();

      this.$refs.unemplyeeRatio.select("#labor-us-btn");
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_1991();
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_2000();
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_2010();
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_2019();

      this.selectCountryLineChart(this.countries[8]);

      this.$refs.retireAge.select("#labor-us-btn");
      this.$refs.retireAge.draw_retire_age_bar_chart();

      this.switchBtnColor("labor-us-btn");
    });

    d3.select("#labor-australia-btn").on("click", () => {
      this.$refs.laborRatio.select("#labor-australia-btn");
      this.$refs.laborRatio.redraw_pie_chart_1991();
      this.$refs.laborRatio.redraw_pie_chart_2000();
      this.$refs.laborRatio.redraw_pie_chart_2010();
      this.$refs.laborRatio.redraw_pie_chart_2019();

      this.$refs.unemplyeeRatio.select("#labor-australia-btn");
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_1991();
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_2000();
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_2010();
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_2019();

      this.selectCountryLineChart(this.countries[9]);

      this.$refs.retireAge.select("#labor-australia-btn");
      this.$refs.retireAge.draw_retire_age_bar_chart();

      this.switchBtnColor("labor-australia-btn");
    });

    d3.select("#labor-iceland-btn").on("click", () => {
      this.$refs.laborRatio.select("#labor-iceland-btn");
      this.$refs.laborRatio.redraw_pie_chart_1991();
      this.$refs.laborRatio.redraw_pie_chart_2000();
      this.$refs.laborRatio.redraw_pie_chart_2010();
      this.$refs.laborRatio.redraw_pie_chart_2019();

      this.$refs.unemplyeeRatio.select("#labor-iceland-btn");
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_1991();
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_2000();
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_2010();
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_2019();

      this.selectCountryLineChart(this.countries[10]);

      this.$refs.retireAge.select("#labor-iceland-btn");
      this.$refs.retireAge.draw_retire_age_bar_chart();

      this.switchBtnColor("labor-iceland-btn");
    });

    d3.select("#labor-chile-btn").on("click", () => {
      this.$refs.laborRatio.select("#labor-chile-btn");
      this.$refs.laborRatio.redraw_pie_chart_1991();
      this.$refs.laborRatio.redraw_pie_chart_2000();
      this.$refs.laborRatio.redraw_pie_chart_2010();
      this.$refs.laborRatio.redraw_pie_chart_2019();

      this.$refs.unemplyeeRatio.select("#labor-chile-btn");
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_1991();
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_2000();
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_2010();
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_2019();

      this.selectCountryLineChart(this.countries[11]);

      this.$refs.retireAge.select("#labor-chile-btn");
      this.$refs.retireAge.draw_retire_age_bar_chart();

      this.switchBtnColor("labor-chile-btn");
    });

    d3.select("#labor-turkey-btn").on("click", () => {
      this.$refs.laborRatio.select("#labor-turkey-btn");
      this.$refs.laborRatio.redraw_pie_chart_1991();
      this.$refs.laborRatio.redraw_pie_chart_2000();
      this.$refs.laborRatio.redraw_pie_chart_2010();
      this.$refs.laborRatio.redraw_pie_chart_2019();

      this.$refs.unemplyeeRatio.select("#labor-turkey-btn");
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_1991();
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_2000();
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_2010();
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_2019();

      this.selectCountryLineChart(this.countries[12]);

      this.$refs.retireAge.select("#labor-turkey-btn");
      this.$refs.retireAge.draw_retire_age_bar_chart();

      this.switchBtnColor("labor-turkey-btn");
    });

    d3.select("#labor-mexico-btn").on("click", () => {
      this.$refs.laborRatio.select("#labor-mexico-btn");
      this.$refs.laborRatio.redraw_pie_chart_1991();
      this.$refs.laborRatio.redraw_pie_chart_2000();
      this.$refs.laborRatio.redraw_pie_chart_2010();
      this.$refs.laborRatio.redraw_pie_chart_2019();

      this.$refs.unemplyeeRatio.select("#labor-mexico-btn");
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_1991();
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_2000();
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_2010();
      this.$refs.unemplyeeRatio.redraw_unemployed_pie_chart_2019();

      this.selectCountryLineChart(this.countries[13]);

      this.$refs.retireAge.select("#labor-mexico-btn");
      this.$refs.retireAge.draw_retire_age_bar_chart();

      this.switchBtnColor("labor-mexico-btn");
    });
  },
  methods: {
    selectCountryLineChart(countryName) {
      d3.selectAll(".unemploy_rate_line, .unemploy_rate_line--hover")
        .filter(function () {
          //console.log('country is ',d3.select(this).attr("country_name")===countryName)
          return d3.select(this).attr("country_name") === countryName;
        })
        .classed("highlight-line", true)
        .classed("fade-line", false);
      d3.selectAll(".unemploy_rate_line, .unemploy_rate_line--hover")
        .filter(function () {
          //console.log('country is ',d3.select(this).attr("country_name")===countryName)
          return d3.select(this).attr("country_name") !== countryName;
        })
        .classed("highlight-line", false)
        .classed("fade-line", true);
    },

    switchBtnColor(countryName) {
      const classPrefix = countryName.substring(6);
      var btn = d3.select(`#${countryName}`).classed(`${classPrefix}-color`);
      if (btn) {
        d3.select(`#${countryName}`).classed(`${classPrefix}-color`, !btn);
        this.selectOthers(countryName);
      }
    },
    selectOthers(countryName) {
      d3.selectAll(".labor-btn").filter(function () {
        let tempId = d3.select(this).property("id");
        if (tempId !== countryName) {
          d3.select(`#${tempId}`).classed(`${tempId.substring(6)}-color`, true);
        }
        return;
      });
    },
  },
};
</script>

<style>
.btnFadeOut {
  background: white !important;
  color: black !important;
}
</style>